<template>
    <div>
        <div class="row">
            <div class="col-md-5 pr-5">
                <div class="form-group">
                    <label class="font-weight-bold">Package dimensions</label>
                    <div class="input-group">
                        <select class="form-control" v-model="package.dimensions">
                            <option :value="defaultDimensions" disabled selected>
                                Please select package dimensions
                            </option>
                            <option v-for="preset in presets" :value="preset.dimensions">
                                {{ preset.name }}
                            </option>
                        </select>
                    </div>
                    <div v-if="package.dimensions" class="mt-2 rounded p-4 bg-light-light">
                        <div class="row">
                            <div v-for="(dimension, type) in package.dimensions" class="col-4 text-center">
                                <div class="font-weight-bold text-uppercase">
                                    {{ type }}
                                </div>
                                <div class="font-size-lg font-weight-light">
                                    {{ dimension.value }}{{ dimension.unit }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <span class="form-text text-muted">
                        Select package dimensions or <a href="#" @click.prevent="showCreateDimensionPreset">create preset</a>.
                    </span>
                    <FormErrors :error="value.errors['dimensions.length.value']"/>
                    <FormErrors :error="value.errors['dimensions.width.value']"/>
                    <FormErrors :error="value.errors['dimensions.height.value']"/>
                </div>
                <div class="row">
                    <div class="col-md-8">
                        <div class="form-group">
                            <label class="font-weight-bold">Total weight</label>
                            <div class="input-group">
                                <input class="form-control" type="number" min="0" v-model="package.weight.value">
                                <div class="input-group-append">
                                    <select class="form-control rounded-left-0" v-model="package.weight.unit">
                                        <option value="gr">gram</option>
                                        <option value="kg">kilogram</option>
                                    </select>
                                </div>
                            </div>
                            <span class="form-text text-muted">Specify the weight of the package.</span>
                            <FormErrors :error="value.errors['weight.value']"/>
                        </div>
                    </div>
                </div>
                <div class="form-group opacity-50 cursor-not-allowed">
                    <label class="font-weight-bold">Hazmat</label>
                    <input class="form-control" type="number" min="0" v-model="package.hazmat" disabled>
                    <span class="form-text text-muted">Enter hazmat information.</span>
                    <FormErrors :error="value.errors.hazmat"/>
                </div>
            </div>

            <div class="col-md-7 pl-5">
                <div class="rounded bg-light-light p-5">
                    <div class="font-weight-bold text-2xl">
                        Package contents
                    </div>
                    <div class="font-weight-light text-lg">
                        Select the articles and the amounts contained in the package.
                    </div>
                    <table class="table table-hover table-vertical-center">
                        <thead>
                        <tr>
                            <th v-if="unpackedItems.length > 1" colspan="2">Remaining item(s) to pack</th>
                            <th v-else colspan="2">Remaining item to pack</th>
                            <th>Quantity</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in package.package_contents">
                            <td>
                                <img class="rounded overflow-hidden w-40px h-40px bg-light-primary"
                                     :src="item.image_url" :alt="item.title">
                            </td>
                            <td>
                                {{ item.title }}
                            </td>
                            <td>
                                <input class="form-control form-control-solid text-center" type="number" min="0"
                                       :max="item.quantity_unpacked" v-model="item.quantity">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PackageDimensionsForm from "@components/Packages/PackageDimensionsForm.vue";
import FormErrors from "../Form/FormErrors.vue";

export default {
    components: {FormErrors, PackageDimensionsForm},

    props: {
        order: Object,
        presets: Array,
        value: {
            type: Object,
            default() {
                return {
                    dimensions: {
                        length: {
                            unit: 'cm',
                            value: 0
                        },
                        width: {
                            unit: 'cm',
                            value: 0
                        },
                        height: {
                            unit: 'cm',
                            value: 0
                        },
                    },
                    weight: {
                        unit: '',
                        value: 0
                    },
                    hazmat: '',
                    package_contents: []
                }
            }
        }
    },

    data() {
        return {
            defaultDimensions: {
                length: {
                    unit: 'cm',
                    value: 0
                },
                width: {
                    unit: 'cm',
                    value: 0
                },
                height: {
                    unit: 'cm',
                    value: 0
                },
            },
            package: this.value
        }
    },

    mounted() {
        this.package.package_contents = this.unpackedItems.map(function (orderItem) {
            return {
                image_url: orderItem.image_url,
                title: orderItem.title,
                identifier_type: orderItem.identifier_type,
                identifier: orderItem.identifier,
                quantity_unpacked: orderItem.quantity_unpacked,
                quantity: orderItem.quantity_unpacked
            }
        })
        this.$emit('input', this.package)
    },

    methods: {
        showCreateDimensionPreset() {

        }
    },

    computed: {
        unpackedItems() {
            let out = [];
            for (let item of this.order.items) {
                if (item.quantity_unpacked > 0) {
                    out.push(item);
                }
            }
            return out;
        }
    },

    watch: {
        package: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue);
            }
        }
    }
}
</script>
